import Vue from 'vue'
import Router from 'vue-router'
import Category from '@/components/Category'
import {categoryData} from '@/categories'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/:cat*',
      component: Category,
      props: function (route) {
        return {category: route.path}
      },
      beforeEnter: (to, from, next) => {
        if (categoryData[to.path]) {
          next()
        } else {
          next('/')
        }
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js